export const UPDATE_OBJECT_PROPERTY_FROM_WEB = gql`
  mutation UpdateObjectPropertyFromWeb(
    $workspaceId: String!
    $objectId: String!
    $objectType: String!
    $propertyId: String!
    $propertyType: String!
    $propertySourceId: String!
    $value: String!
    $reasoning: String
    $sources: [JSON!]
    $aiFeature: String
    $aiFeatureVersion: String
  ) {
    updateObjectPropertyFromWeb(
      workspaceId: $workspaceId
      objectId: $objectId
      objectType: $objectType
      propertyId: $propertyId
      propertyType: $propertyType
      propertySourceId: $propertySourceId
      value: $value
      reasoning: $reasoning
      sources: $sources
      aiFeature: $aiFeature
      aiFeatureVersion: $aiFeatureVersion
    )
  }
`

export const CREATE_OBJECT_FROM_WEB = gql`
  mutation CreateObjectFromWeb(
    $workspaceId: String!
    $objectId: String!
    $objectType: String!
  ) {
    createObject(
      workspaceId: $workspaceId
      objectId: $objectId
      objectType: $objectType
    )
  }
`
